// pages/Home.js
import React, { useState } from "react";
import PropertyCategoryCarousel from "../../../components/pages/Home/PropertyCategoryCarousel";
import SidebarFilter from "../../../components/pages/Home/SidebarFilter";
import PropertyListingArea from "../../../components/pages/Home/PropertyListingArea";
import SEO from "../../../components/pages/SEO/SEO";
/**
 * 🏠 Home Component
 * - Quản lý bộ lọc tìm kiếm xe (filters)
 * - Hiển thị danh mục xe nổi bật, sidebar bộ lọc và danh sách xe
 */
export default function Home() {
    const [filters, setFilters] = useState({});
    // ✅ SEO data cho trang Home
    const seoData = {
        title: "Mỹ Diệp Property | Mua bán & cho thuê bất động sản cao cấp",
        description: "Sàn giao dịch BĐS Vinhomes – mua bán, cho thuê căn hộ, biệt thự, shophouse chính chủ. Tìm dự án, xem bảng giá và nhận tư vấn nhanh.",
        keywords: "Vinhomes, bất động sản, căn hộ, biệt thự, shophouse, mua bán, cho thuê, dự án Vinhomes",
        image: "/images/vinhomes-banner.jpg",
        type: "website",
        url: typeof window !== "undefined" ? window.location.href : undefined,
        schema: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Mỹ Diệp Property",
            "description": "Sàn giao dịch BĐS Vinhomes – mua bán, cho thuê căn hộ, biệt thự, shophouse chính chủ",
            "url": typeof window !== "undefined" ? window.location.href : "https://vinhomesdemo.com",
            "publisher": {
                "@type": "Organization",
                "name": "Mỹ Diệp Property",
                "logo": {
                    "@type": "ImageObject",
                    "url": "/images/logo.png"
                }
            }
        }
    };
    // 🔹 State filters: Lưu các điều kiện lọc (ví dụ: hãng xe, giá, năm sản xuất...)
    // 🔹 setFilters: Hàm cập nhật điều kiện lọc

    // 📌 Render giao diện trang chủ
    return (
        <div className="space-y-6 text-blue-900">
            {/* 🚀 SEO Meta */}
            <SEO {...seoData} />

            {/* 🏆 Danh mục dự án nổi bật */}
            <section>
                <h2 className="text-2xl font-bold p-4">Dự án nổi bật</h2>
                <PropertyCategoryCarousel />
            </section>

            <section className="flex gap-6">
                <SidebarFilter filters={filters} setFilters={setFilters} />
                <PropertyListingArea filters={filters} setFilters={setFilters} />
            </section>
        </div>
    );
}
